goog.provide('el8.appchart.mainFeeds.reqActRenderer');

goog.require('el8.appchart.mainFeeds.actions');
goog.require('el8.appchart.mainFeeds.reqActReactRenderMap');
goog.require('el8.appchart.permissions');
goog.require('el8.data.base');
goog.require('el8.data.referencedUsers');
goog.require('el8.data.practiceUsers');
goog.require('el8.ptdata.base');
goog.require('el8.ptdata.fetchById');
goog.require('el8.service.tz');
goog.require('el8.template.render.reqActFeedItem');
goog.require('el8.template.render.reqActFeedItemNew');
goog.require('el8.util.datecompare');

goog.require("el8.model.identify");

function convertLinks(html) {
    function maybeAddProtocol(string) {
        if (!string.includes('http')){
            return "http://" + string;
        } else {
            return string;
        }
    }
    var regex = /((https?)(:\/\/))?(www\.)([^\s<>]+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/g;
    function link(value) {
        return '<a href="' + maybeAddProtocol(value) + '" target="_blank" rel="noopener">' + value + '</a>';
    }

    return $(html).html($(html).html().replace(regex, link));
}

el8.appchart.mainFeeds.reqActRenderer = function(item, indexedItem) {
    var mClass = indexedItem.model_class;

    var _templateFn = el8.template.render.reqActFeedItemNew;

    switch (mClass) {
        case "Report":
            return function(item, feedId) {
              return _templateFn.reportItem({
                feedId: feedId,
                feedItemId: item.getFeedItemId(),
                feedDate: el8.service.tz.soyStr(item.getChartFeedDate()),
                buttonsInfo: el8.appchart.mainFeeds.actions.reqActButtons(item),
                report: item.asSoyMap(),
                referringThreads: item
                  .getReferringThreads()
                  .map(el8.model.toSoyMapFn),
                isPhysician: el8.data.currUser.isPhysician(),
                isSignOffAllowed: item.isSignOffAllowed(),
                isStaffReviewAllowed: el8.data.currUser.isOfficeStaff() && item.isStaffReviewAllowed(), 
                actions: el8.appchart.mainFeeds.actions.reqActActionsNew(item)
              });
            };
        case "LabOrder":
        case "ImagingOrder":
        case "SleepOrder":
        case "CardiacOrder":
        case "PulmonaryOrder":
        case "ReferralOrder":
            return function(item, feedId) {
                return _templateFn.orderItem({
                    feedId: feedId,
                    feedItemId: item.getFeedItemId(),
                    feedDate: el8.service.tz.soyStr(item.getChartFeedDate()),
                    buttonsInfo: el8.appchart.mainFeeds.actions.reqActButtons(item),
                    order: item.asSoyMap(),
                    currUserId: el8.data.currUser.getId(),
                    actions: el8.appchart.mainFeeds.actions.reqActActionsNew(item)
                });
            };
        case "MedOrder":
            return function(item, feedId) {
                return _templateFn.medOrderItem({
                    feedId: feedId,
                    feedItemId: item.getFeedItemId(),
                    feedDate: el8.service.tz.soyStr(item.getChartFeedDate()),
                    buttonsInfo: el8.appchart.mainFeeds.actions.reqActButtons(item),
                    order: $.extend(item.asSoyMap(), {
                        isWrittenOnStartDate: el8.util.datecompare.isSameDay(item.getChartFeedDate(), item.getStartDate())
                    }),
                    hasActions: true, // TODO: NewChartFeed Don't think hasActions applies to feed items anymore
                    currUserId: el8.data.currUser.getId(),
                    actions: el8.appchart.mainFeeds.actions.reqActActionsNew(item)
                });
            };
        case "MessageThread":
            return function(item, feedId) {
                var inChart = (el8Globals['APP'] === 'chart');
                var soyMap = item.asSoyMap(inChart);
                var isPostDated = item.getDeliveryDate() &&
                    (item.getDeliveryDate() > el8.service.tz.now());
                $.extend(soyMap, {
                    feedId : feedId,
                    feedItemId : item.getFeedItemId(),
                    feedDate : el8.service.tz.soyStr(item.getChartFeedDate()),
                    buttonsInfo : el8.appchart.mainFeeds.actions.reqActButtons(item),
                    isPostDated : isPostDated,
                    actions: el8.appchart.mainFeeds.actions.reqActActionsNew(item),
                    useNewMessages: el8Globals.FEATURES.NewOfficeMessages
                });

                return _templateFn.messageThread(soyMap);
            };
        case "VisitNote":
            return function(item, feedId) {
                return _templateFn.visitNote({
                    id: item.getId(),
                    feedId: feedId,
                    feedItemId: item.getFeedItemId(),
                    feedDate: el8.service.tz.soyStr(item.getChartFeedDate()),
                    description: item.getDescription(),
                    headerSummary: item.getHeaderSummary().substr(0, 100),
                    bill: (item.getBill()) ? item.getBill().asSoyMap() : null,
                    signDate: item.getSignDate(),
                    buttonsInfo: el8.appchart.mainFeeds.actions.reqActButtons(item),
                    physicianFullName: item.getPhysicianFullName(),
                    signUserId: item.getSignUserId(),
                    currUserId: el8.data.currUser.getId(),
                    actions: el8.appchart.mainFeeds.actions.reqActActionsNew(item)
                });
            };
        case "IncomingDirectMessage":
            return function(item, feedId) {
                return _templateFn.incomingDirectMessage({
                    id: item.getId(),
                    patient: el8.ptdata.currPatient.asSoyMap(),
                    feedId: feedId,
                    feedItemId: item.getFeedItemId(),
                    feedDate: el8.service.tz.soyStr(item.getChartFeedDate()),
                    attachments: item.getAttachments(),
                    subject: item.getSubject(),
                    content: item.getContent(),
                    fromAddress: item.getFromAddress(),
                    ccdaContentFileName: item.getCcdaContentFileName(),
                    actions: el8.appchart.mainFeeds.actions.reqActActionsNew(item)
                });
            };
        case "NonvisitNote":
            return function(item, feedId) {
                var noteType = el8.data.nonvisitNoteTypes.getById(item.getNoteTypeId());
                // if it's type direct, we treat this like an incoming direct message
                if (noteType.getName().toUpperCase() === 'DIRECT') {
                    var map = item.asSoyMap();
                    return _templateFn.nonvisitNoteAsIncomingDirectMessage({
                        id: item.getId(),
                        patient: el8.ptdata.currPatient.asSoyMap(),
                        feedId: feedId,
                        feedItemId: item.getFeedItemId(),
                        feedDate: el8.service.tz.soyStr(item.getChartFeedDate()),
                        attachments: map['attachments'],
                        subject: map['associatedEmail']['subject'],
                        content: map['associatedEmail']['content'],
                        fromAddress: map['associatedEmail']['from_email'],
                        xmlPatientSummary: map['associatedXmlSummary'],
                        ccdaContentFileName: map['ccdaContentFileName'],
                        actions: el8.appchart.mainFeeds.actions.reqActActionsNew(item)
                    });
                } else {
                    // otherwise, we treat it as normal, goold ol' nonvisitnote
                    return _templateFn.nonvisitNote({
                        feedId: feedId,
                        feedItemId: item.getFeedItemId(),
                        feedDate: el8.service.tz.soyStr(item.getChartFeedDate()),
                        description: item.getDescription()
                    });
                }
            };
        case "RxRefillRequest":
            return function(item, feedId) {
                var isControlled = item.isMedicationControlled();
                return _templateFn.rxRefillRequest({
                    feedId: feedId,
                    feedItemId: item.getFeedItemId(),
                    feedDate: el8.service.tz.soyStr(item.getReceivedTime()),
                    prescriberName: item.getPrescriberName(),
                    pharmacyName: item.getPharmacyName(),
                    pharmacyPhone: item.getPharmacyPhone(),
                    isControlled: isControlled,
                    isReadyToAccept: item.isReadyToAccept(),
                    buttonsInfo: el8.appchart.mainFeeds.actions.buttons(item),
                    originalMedOrder: item.getOriginalMedOrder() ? item.getOriginalMedOrder().asSoyMap() : null,
                    userCanAddress: el8.appchart.permissions.allow('addressRxRequests', [item.getPrescriberId(), isControlled]),
                    userCanApprove: !(el8Globals.FEATURES.NewSurescriptsEPCS && isControlled),
                    prescribedMedication: item.getPrescribedMedication().asSoyMap(),
                    dispensedMedication: item.getDispensedMedication().asSoyMap(),
                    dispensedAsPrescribed : item.isDispensedAsPrescribed(),
                    actions: el8.appchart.mainFeeds.actions.reqActActionsNew(item),
                    followupNumber: item.getFollowupNumber()
                });
            };
        case "PharmacyPrescriptionRequest":
            return function(item, feedId) {
                var prescribedPrescription = item.getPrescriptionPrescribed().asSoyMap()
                var requestedPrescription = item.getPrescriptionRequested();
                var requestedPrescriptionSoyMap = requestedPrescription ? item.getPrescriptionRequested().asSoyMap() : null;
                var prescriptionChangedValuesMap = requestedPrescription ? Object.keys(requestedPrescriptionSoyMap).reduce(
                  function(accum, prescriptionKey) {
                    accum[prescriptionKey] =
                        prescribedPrescription[prescriptionKey] !== requestedPrescriptionSoyMap[prescriptionKey]

                    return accum
                  },
                  {}
                ) : undefined
                return el8React.templates.renderPharmacyPrescriptionRequest({
                    feedId: feedId,
                    feedItemId: item.getFeedItemId(),
                    feedDate: item.getChartFeedDate(),
                    followupNumber: item.getFollowupNumber(),
                    prescriptionPrescribed: prescribedPrescription,
                    prescriptionRequested: requestedPrescriptionSoyMap,
                    prescriptionChangedValuesMap: prescriptionChangedValuesMap,
                    changeRequestType: item.getChangeRequestType(),
                    payerName: item.getPayerName(),
                    prescriberName: item.getPrescriberName(),
                    pharmacy: item.getPharmacy(),
                    pharmacistName: item.getPharmacistName(),
                    originalMedOrder: item.getOriginalMedOrder().asSoyMap(),
                    userCanAddress: el8.appchart.permissions.allow(
                        'addressRxRequests',
                        [item.getPrescriberId(), item.getOriginalMedOrder().isControlled()]
                    ),
                    buttonsInfo: el8.appchart.mainFeeds.actions.buttons(item),
                    actions: el8.appchart.mainFeeds.actions.reqActActionsNew(item)
                });
            };
        case "RxHistoryDownloadSummary":
            return function(item, feedId) {
                var result = _templateFn.rxHistoryDownload({
                    feedId: feedId,
                    feedItemId: item.getFeedItemId(),
                    feedDate: el8.service.tz.soyStr(item.getChartFeedDate()),
                    buttonsInfo: el8.appchart.mainFeeds.actions.reqActButtons(item),
                    summaryItem: item.asSoyMap(),
                    actions: el8.appchart.mainFeeds.actions.reqActActionsNew(item)
                });
                return result;
            };

        case "VisitNoteEdit":
            return function(item, feedId) {
                return _templateFn.visitNoteEdit({
                    feedId: feedId,
                    feedItemId: item.getFeedItemId(),
                    feedDate: el8.service.tz.soyStr(item.getCreateDate()),
                    description: item.getDescription(),
                    headerSummary: item.getVisitNote().getHeaderSummary().substr(0, 70),
                    createUserName: item.getCreateUserName()
                });
            };
        case "Letter":
            return function(letter, feedId) {
                var soyMap = letter.asSoyMap();
                return convertLinks(_templateFn.letterItem({
                    feedId: feedId,
                    feedItemId: letter.getFeedItemId(),
                    feedDate: el8.service.tz.soyStr(letter.getChartFeedDate()),
                    buttonsInfo: el8.appchart.mainFeeds.actions.reqActButtons(letter),
                    patient: el8.ptdata.currPatient.asSoyMap(),
                    letter: soyMap,
                    currUserId: el8.data.currUser.getId(),
                    actions: el8.appchart.mainFeeds.actions.reqActActionsNew(item)
                }));
            };

        case "LetterReceipt":
            return function(letterReceipt, feedId) {
                return convertLinks(_templateFn.letterReceipt({
                    feedId: feedId,
                    feedItemId: letterReceipt.getFeedItemId(),
                    feedDate: el8.service.tz.soyStr(letterReceipt.getChartFeedDate()),
                    buttonsInfo: el8.appchart.mainFeeds.actions.reqActButtons(letterReceipt),
                    patient: el8.ptdata.currPatient.asSoyMap(),
                    letterReceipt: letterReceipt.asSoyMap(),
                    actions: el8.appchart.mainFeeds.actions.reqActActionsNew(item)
                }));
            };

        case "UnreadLetterNotification":
            return function(unreadLetterNotification, feedId) {
                var soyMap = unreadLetterNotification.asSoyMap();

                return _templateFn.unreadLetterNotificationItem({
                    feedId: feedId,
                    feedItemId: unreadLetterNotification.getFeedItemId(),
                    feedDate: el8.service.tz.soyStr(unreadLetterNotification.getChartFeedDate()),
                    buttonsInfo: el8.appchart.mainFeeds.actions.buttons(unreadLetterNotification),
                    patient: el8.ptdata.currPatient.asSoyMap(),
                    unreadLetterNotification: soyMap,
                    letter: unreadLetterNotification.getLetter().asSoyMap(),
                    actions: el8.appchart.mainFeeds.actions.reqActActionsNew(item)
                });
            };
        case "XmlPatientSummary":
            return function(summary, feedId) {
                return _templateFn.xmlSummaryItem({
                    feedId: feedId,
                    feedItemId: summary.getFeedItemId(),
                    feedDate: el8.service.tz.soyStr(summary.getChartFeedDate()),
                    buttonsInfo: el8.appchart.mainFeeds.actions.buttons(summary),
                    summaryItem: summary.asSoyMap(),
                    actions: el8.appchart.mainFeeds.actions.reqActActionsNew(item)
                });
            };
        case "Hl7Message":
            return function(message, feedId) {
                return _templateFn.hl7MessageItem({
                    feedId: feedId,
                    feedItemId: message.getFeedItemId(),
                    feedDate: el8.service.tz.soyStr(message.getChartFeedDate()),
                    buttonsInfo: el8.appchart.mainFeeds.actions.buttons(message),
                    messageItem: message.asSoyMap(),
                    actions: el8.appchart.mainFeeds.actions.reqActActionsNew(item)
                });
            };
        case "PatientCollaboratorNotification":
            return function(notification, feedId) {
                return _templateFn.plrCollaboratorNotification({
                    feedId: feedId,
                    feedItemId: notification.getFeedItemId(),
                    feedDate: el8.service.tz.soyStr(notification.getChartFeedDate()),
                    buttonsInfo: el8.appchart.mainFeeds.actions.buttons(notification),
                    item: notification.asSoyMap(),
                    actions: el8.appchart.mainFeeds.actions.reqActActionsNew(item)
                });
            };

        case "DocumentReminderNotification":
            return function(documentReminderNotification, feedId) {
                var soyMap = documentReminderNotification.asSoyMap();

                return _templateFn.documentReminderNotificationItem({
                    feedId: feedId,
                    feedItemId: documentReminderNotification.getFeedItemId(),
                    feedDate: el8.service.tz.soyStr(documentReminderNotification.getChartFeedDate()),
                    buttonsInfo: el8.appchart.mainFeeds.actions.buttons(documentReminderNotification),
                    patient: el8.ptdata.currPatient.asSoyMap(),
                    documentReminderNotification: soyMap,
                    actions: el8.appchart.mainFeeds.actions.reqActActionsNew(item)
                });
            };

        case "VipAccessNotification":
            return function(notification, feedId) {
                return _templateFn.vipAccessNotification({
                    feedId: feedId,
                    feedItemId: notification.getFeedItemId(),
                    feedDate: el8.service.tz.soyStr(notification.getChartFeedDate()),
                    buttonsInfo: el8.appchart.mainFeeds.actions.buttons(notification),
                    item: notification.asSoyMap(),
                    actions: el8.appchart.mainFeeds.actions.reqActActionsNew(item)
                });
            };

        case "PmpCheckNotification":
            return function(notification, feedId) {
                return _templateFn.pmpCheckNotification({
                    feedId: feedId,
                    feedItemId: notification.getFeedItemId(),
                    feedDate: el8.service.tz.soyStr(notification.getChartFeedDate()),
                    buttonsInfo: el8.appchart.mainFeeds.actions.buttons(notification),
                    item: notification.asSoyMap(),
                    actions: el8.appchart.mainFeeds.actions.reqActActionsNew(item)
                });
            };

        case "PrenatalFlowsheetVisitMeasurements":
            return function(prenatalFlowsheetVisitMeasurements, feedId) {
                return _templateFn.prenatalFlowsheetVisitMeasurements({
                    visitMeasurements: prenatalFlowsheetVisitMeasurements.asSoyMap(),
                    flowsheet: prenatalFlowsheetVisitMeasurements.getFlowsheet().asSoyMap(),
                    feedId: feedId,
                    feedItemId: prenatalFlowsheetVisitMeasurements.getFeedItemId(),
                    feedDate: el8.service.tz.soyStr(prenatalFlowsheetVisitMeasurements.getChartFeedDate()),
                    buttonsInfo: el8.appchart.mainFeeds.actions.buttons(prenatalFlowsheetVisitMeasurements),
                    actions: el8.appchart.mainFeeds.actions.reqActActionsNew(item)
                });
            };

        default:
            var shouldRenderReactContainer = Boolean(el8.appchart.mainFeeds.reqActReactRenderMap[mClass]);
            if (shouldRenderReactContainer) {
                return function(item, feedId) {
                    return _templateFn.reactItem({
                        feedId: feedId
                    });
                };  
            }
            break;
    }
};
